import React, { useContext, useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import GetlogData from '../../api/GetlogData.api';
import LoginContext from '../../context/login_context/LoginContext';
import { LineChart, Line, ResponsiveContainer, Tooltip } from 'recharts';

export const LogsLogin = () => {

    const {LoginState} = useContext(LoginContext);
    // console.log(LoginState.planta)

    const [DataListLog, setDataListLog] = useState([]);
    const [Orden, setOrden] = useState("DESC");//DESC || ASC
    const [OrdenTxt, setOrdenTxt] = useState("");//Item de tabla

    // Componente mini gráfico de historial
    const MiniLoginChart = ({ fechas }) => {
        if (!Array.isArray(fechas) || fechas.length === 0) {
            return <small style={{color: '#999'}}>Sin datos</small>;
        }

        // Procesar fechas y contar logins por día
        const processData = () => {
            const loginsByDay = {};
            
            fechas.forEach(fecha => {
                // Parsear formato "16-12-2025 11:26:13 a. m."
                const [datePart] = fecha.split(' ');
                const [day, month, year] = datePart.split('-');
                const dateKey = `${day}/${month}`;
                
                loginsByDay[dateKey] = (loginsByDay[dateKey] || 0) + 1;
            });

            // Convertir a array para el gráfico
            return Object.entries(loginsByDay).map(([date, count]) => ({
                date,
                logins: count
            }));
        };

        const data = processData();

        // Tooltip personalizado para mostrar la fecha correctamente
        const CustomTooltip = ({ active, payload }) => {
            if (active && payload && payload.length) {
                const { date, logins } = payload[0].payload;
                return (
                    <div style={{ 
                        backgroundColor: 'white', 
                        padding: '4px 8px', 
                        border: '1px solid #ccc',
                        borderRadius: '3px',
                        fontSize: '10px'
                    }}>
                        <p style={{ margin: 0 }}><b>Fecha:</b> {date}</p>
                        <p style={{ margin: 0 }}><b>Logins:</b> {logins}</p>
                    </div>
                );
            }
            return null;
        };

        return (
            <ResponsiveContainer width="100%" height={40}>
                <LineChart data={data} margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
                    <Line 
                        type="monotone" 
                        dataKey="logins" 
                        stroke="#0d6efd" 
                        strokeWidth={2}
                        dot={{ r: 2 }}
                    />
                    <Tooltip content={<CustomTooltip />} />
                </LineChart>
            </ResponsiveContainer>
        );
    };

    const ObteinDataLogs = async () => {
        //llamar api para obtener los datos de los logs de inicio de sesion
        let dataLog = await GetlogData({EMPRESA:LoginState.planta})
        // console.log(dataLog)
        setDataListLog(dataLog)
    }

    useEffect(() => {
        ObteinDataLogs();
        return () => {
            ObteinDataLogs();
        }
    }, [])
    

    function ordenarData(data, key, ord = 'ASC') {
        if (!Array.isArray(data)) throw new TypeError('data debe ser un array');
        const arr = [...data]; // clonar para no mutar el original
        const order = (ord || 'ASC').toUpperCase(); // normalizar

        const tryParseDate = (v) => {
        if (typeof v !== 'string') return null;
        const m = v.match(/^(\d{2})\/(\d{2})\/(\d{4}),?\s+(\d{2}):(\d{2}):(\d{2})$/);
        if (m) {
            const [, dd, mm, yyyy, HH, MM, SS] = m;
            const ts = Date.parse(`${yyyy}-${mm}-${dd}T${HH}:${MM}:${SS}Z`);
            return isNaN(ts) ? null : ts;
        }
        const ts = Date.parse(v);
        return isNaN(ts) ? null : ts;
        };

        const norm = (v) => {
        if (v == null) return { t: 'null', v: -Infinity };
        if (typeof v === 'number') return { t: 'num', v };
        if (typeof v === 'boolean') return { t: 'num', v: v ? 1 : 0 };
        if (typeof v === 'string') {
            const num = Number(v.replace(/,/g, ''));
            if (!isNaN(num) && v.trim() !== '') return { t: 'num', v: num };
            const d = tryParseDate(v);
            if (d != null) return { t: 'date', v: d };
            return { t: 'str', v: v.toLowerCase() };
        }
        return { t: 'str', v: JSON.stringify(v).toLowerCase() };
        };

        arr.sort((a, b) => {
        const A = norm(a[key]);
        const B = norm(b[key]);
        const typePriority = { num: 3, date: 3, str: 2, null: 1 };
        const tpA = typePriority[A.t] || 0;
        const tpB = typePriority[B.t] || 0;
        if (tpA !== tpB) return (tpB - tpA) * (order === 'ASC' ? -1 : 1);

        let cmp = 0;
        if (A.v < B.v) cmp = -1;
        else if (A.v > B.v) cmp = 1;

        if (order === 'DESC') cmp = -cmp;
        return cmp;
        });

        setOrdenTxt(key);//item para ordenar
        setOrden(order === 'ASC' ? 'DESC' : 'ASC');
        setDataListLog(arr);//resultado del array ordenado
        return arr;
    }

    return (<>
        <HeaderMenu Pag_Sel={'logs_login'}/>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>
                    <h5>Logs de Inicio de Sesión</h5>
                </div>
                <div className='col-12 m-0 p-0'>
                    <table className="table table-sm my-0" >
                        <thead className='text-white header-table' style={{ top: 0, width: '90%', zIndex: 1}}>
                            <tr>
                                <th className='fondo-oscuro' style={{width: '10%'}} onClick={()=>ordenarData(DataListLog, "_id", Orden)}>
                                    <b><small>RUT{OrdenTxt === "_id" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small></b>
                                </th>
                                <th className='fondo-oscuro' style={{width: '40%'}} onClick={()=>ordenarData(DataListLog, "NOMBRE", Orden)}>
                                    <b><small>NOMBRE{OrdenTxt === "NOMBRE" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small></b>
                                </th>
                                <th className='fondo-oscuro' style={{width: '20%'}} onClick={()=>ordenarData(DataListLog, "CARGO", Orden)}>
                                    <b><small>AREA{OrdenTxt === "CARGO" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small></b>
                                </th>
                                <th className='fondo-oscuro' style={{width: '15%'}} onClick={()=>ordenarData(DataListLog, "COUNT", Orden)}>
                                    <b><small>EVENTOS{OrdenTxt === "COUNT" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small></b>
                                </th>
                                <th className='fondo-oscuro' style={{width: '15%'}} >
                                    <b><small>HISTORIAL</small></b>
                                </th>
                                <th style={{width: '1%', backgroundColor: 'transparent'}} >
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div className="col-12 m-0 p-0 mb-5" style={{overflowY:"scroll", height:"80vh", position: 'relative', backgroundColor: 'white'}}>
                    <table className="table table-sm table-hover table-striped m-0" style={{position: 'static', top: 0}}>
                        <tbody>
                            {
                                DataListLog.map((oec, index) => {
                                    return (
                                        <tr key={index}>
                                            <td style={{width: '10%'}}><small>{oec._id}</small></td>
                                            <td style={{width: '40%'}}><small>{oec.NOMBRE}</small></td>
                                            <td style={{width: '20%'}}><small>{oec.CARGO}</small></td>
                                            <td style={{width: '15%'}}><small>{oec.COUNT}</small></td>
                                            <td style={{width: '15%'}}>
                                                <MiniLoginChart fechas={oec.FECHA} />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </>
  )
}
